import { call, put, select, take } from 'redux-saga/effects';
import { selectDraft, selectSumToReturn } from 'modules/Taps/components/NDFL3Light/selectors';
import { updateXmlDraft, updateDraft } from 'modules/Taps/components/NDFL3Light/redux/actions';
import {
  UPDATE_XML_DRAFT_SUCCESS,
  UPDATE_DRAFT_SUCCESS,
} from 'modules/Taps/components/NDFL3Light/redux/actionTypes';
import { BASE_ACTIONS } from 'modules/Taps/redux/ndfl3Saga/NDFL3SagaActionTypes';

export default function* initSaga() {
  let draft = yield select(selectDraft);
  const sumToReturn = yield select(selectSumToReturn);

  if (
    !sumToReturn &&
    (draft.getIn(['payload', 'useReturnClaim', 'use']) ||
      draft.getIn(['payload', 'useReturnClaim', 'return']))
  ) {
    draft = draft.setIn(['payload', 'useReturnClaim'], null);
    yield put(updateDraft({ draft }));
    yield take(UPDATE_DRAFT_SUCCESS);
  }

  yield put(updateXmlDraft(draft));
  yield take(UPDATE_XML_DRAFT_SUCCESS);
  yield call(BASE_ACTIONS.GET_FILES_CATEGORIES.sagaFunction, {
    payload: { year: draft.getIn(['payload', 'initialData', 'reportYear']) },
  });
}
